import React, { Component } from "react";
import CardGroup from "pages/Course/Components/CardGroup/CardGroup";
// import CardSingle from "./CardSingle/CardSingle";
// import image from "assets/images/content.jpg";
import Modules from "./Modules";
// import Css from "./chapter-inner.module.scss";
// import { Spinner } from "components";
import styled from "styled-components";
import { rgba } from "polished";

// const dataCompleted = {
//   time: "0:40",
//   credit: "",
//   image,
//   title: "Physics Fundamentals",
//   assigned: "MAR 31, 2021",
//   completed: "APR 16, 2021",
//   isCompleted: true,
//   progress: 100,
// };

// const dataCurrent = {
//   time: "0:40",
//   credit: "9 / 20 CREDITS",
//   image,
//   title: "Newton’s Laws",
//   assigned: "MAR 31, 2021",
//   progress: 40,
//   isCurrent: true,
// };

const CardStyle = styled.div`
&& {
  border: 1px solid ${({ theme }) => rgba(theme.primary, 0.5)};
  border-radius: 10px;
  margin-bottom: 5px
   
}
`;

class ChapterList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seq: [],
      loading: false,
    };
  }

  handleToggleChapter = (i, exp) => {
    this.setState((s0) => {
      let seq = s0.seq;
      if (s0.seq.includes(i)) {
        seq = seq.filter((se) => se !== i);
      } else {
        seq.push(i);
      }
      return { seq };
    });
  };

  handleSequenceChange =
    (chIdx) => (newSeq, modId, cardIndex, parentId, modIdx) => {
      this.props.onSequenceChange(
        newSeq,
        modId,
        cardIndex,
        parentId,
        modIdx,
        chIdx
      );
    };

    handleChapterSequence = (chIdx) => (newSeq,chapId)=> {
      this.props.onChapterSequence (
        newSeq,chapId,chIdx
      );
    };
  
  renderChapterItem = (chapter, i) => {
    const modules = chapter?.contents
    const isExpand = this.state.seq.includes(i);
    return (
      <CardStyle>
      <CardGroup
      isContentBuilder
        key={chapter.id + 1}
        title={chapter.chapterName}
        number={i + 1}
        //total={chapter.contents.length}         
        isOpen={true}
        preview={this.props.preview}
        onSelectEntity={this.props.onSelectEntity}
        onDeleteEntity={this.props.onDeleteEntity}
        chapter={chapter}
        onAddModule={this.props.onAddModule}
        onAddTest={this.props.onAddTest}
        activeEntityDetails={this.props.activeEntityDetails}
        sequenceUpdate={this.props.sequenceUpdate}
        editSeq={this.props.editSeq}
        onUpdateSeq={this.props.handleUpdateSeq}
        chapterUpdateSeq = {this.props.chapterUpdateSeq}
        modifiable = {chapter.modifiable}
        createdId = {chapter.createdId}
        createrId = {this.props.createrId}
        onChapterSequence={this.handleChapterSequence(i)}
      >
        <Modules
          // key={chapter.id}
          // items={content}
          chapterId={chapter.id}
          onSequence={this.handleSequenceChange(i)}
          // onSequenceChange = {this.props.onSequenceChange}
          onSeqButtonClick={this.props.onSeqButtonClick}
          // type={content.type}
          canModify={this.props.canModify}
          modules={modules}
          chapterIndex={i}
          {...this.props}
          activeEntityDetails={this.props.activeEntityDetails}
          modifiable = {chapter.modifiable}
          createdId = {chapter.createdId}
          createrId = {this.props.createrId}
          disabledMode = {this.props.disabledMode}

          
        />
      </CardGroup>
    </CardStyle>
    );
  };
  renderChapterProgressItem = () => {

    return (
      <CardStyle>
        <CardGroup
          title={this.props.chapterName}
          chapterProgress={this.props.chapterProgress}
          onClick={this.props.expandChapter}
          number={this.props.number}
          total={this.props.total}
          onSelectEntity={this.onSelectEntity}
        >
          <Modules
            modules={this.props.moduleDetails}
            chapterProgress={this.props.chapterProgress}
          />
        </CardGroup>
      </CardStyle>
    )
  }
  render = () => {
    //  if (this.props.loading) {
      // return <Spinner />;
// }
    return (
       <>
        {
    !this.props.chapterProgress &&
      this.props.chapterSections.map((chapter, i) => (
       <React.Fragment key={i}>
          {this.renderChapterItem(chapter, i)}
        </React.Fragment>
       ))}
     {this.props.chapterProgress && this.props.total &&
      <React.Fragment>
      {this.renderChapterProgressItem()}
      </React.Fragment>
     } 

        
      </>
    );
  };
}

export default ChapterList;
